import { StateSchema } from 'app/config/storeConfig/types';
import { SizeCode } from 'entities/SizeCode';
import { Warehouse } from 'entities/Warehouse';
import { StepData } from 'features/Stepper';
import { PriceChangeParams } from '../types';

export const getOpenedState = (state: StateSchema): boolean => state.changePricesModal.isOpened;
export const getSteps = (state: StateSchema): StepData[] => state.changePricesModal.steps;
export const getSelectedWarehouse = (state: StateSchema): Nullable<Warehouse> => state.changePricesModal.selectedWarehouse;
export const getSelectedSizeCodes = (state: StateSchema): SizeCode[] => state.changePricesModal.selectedSizeCodes;
export const getPriceChangeParams = (state: StateSchema): PriceChangeParams => state.changePricesModal.priceChangeParams;
